<style lang="scss">
.workshopCard::-webkit-scrollbar {
  display: none;
}
</style>

<template>
  <div ref="cardContainer" class="workshopCard" style="overflow: auto;height: 100%;position: relative;">
    <div class="titleBar" style="padding: 20px;display: flex;align-items:center ;position: sticky;top: 0;background: #202027;padding-bottom: 10px;">
      <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
      <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
        {{ $t('shebeijiankong') }}
      </p>
      <div style="display: flex;margin-left: 24px;align-items: center;">
        <div style="display: flex;align-items: center;">
          <div style="width: 8px;height: 8px;border-radius: 50%;background-color: white;"></div>
          <div style="font-size: 14px;font-weight: bold;color: white;margin-left: 4px;">{{ $t('zongshu') }}</div>
          <div style="font-size: 14px;font-weight: bold;;color: white;margin-left: 4px;">{{ equipmentsCal.totalTools }}</div>
        </div>
        <div style="display: flex;align-items: center;margin-left: 24px;">
          <div style="width: 8px;height: 8px;border-radius: 50%;background-color: #39F16D;"></div>
          <div style="font-size: 14px;font-weight: bold;;color: #39F16D;margin-left: 4px;">{{ $t('使用中') }}</div>
          <div style="font-size: 14px;font-weight: bold;;color: #39F16D;margin-left: 4px;">{{ equipmentsCal.inUseTools }}</div>
        </div>
        <div style="display: flex;align-items: center;margin-left: 24px;">
          <div style="width: 8px;height: 8px;border-radius: 50%;background-color: #FFC83A;"></div>
          <div style="font-size: 14px;font-weight: bold;;color: #FFC83A;margin-left: 4px;">{{ $t('空闲中') }}</div>
          <div style="font-size: 14px;font-weight: bold;;color: #FFC83A;margin-left: 4px;">{{ equipmentsCal.idleTools }}</div>
        </div>

      </div>
    </div>
    <!--    v-show="monitorSetting.MONITOR_WORKSHOP_CARD_STATUS_SHOW_RUNTYPE == 'moren'"-->
    <div class="equipments" :style="{ 'grid-template-columns': 'repeat(auto-fill, ' + 240 + 'px)' }" style=";padding:20px;padding-top: 0;display: grid;grid-template-columns:repeat(auto-fill, 176px);grid-row-gap: 7px;grid-column-gap: 7px;">
      <div class="equipment" style="background: #121212;width: 100%;border-radius: 4px 4px 4px 4px;" v-for="(equipment, index) in equipments">
        <div :style="{ background: cardBarColor(index) }" style="width: 100%;;height: 8px;border-radius: 4px 4px 0px 0px;"></div>
        <div style="padding: 12px;">
          <div style="display: flex;justify-content: space-between;">
            <p :style="{ color: cardTextColor(index) }" style="font-size: 24px;word-break: break-all;">{{ equipment.toolName }}</p>
          </div>
          <p v-show="false" :style="{ color: cardTextColor(index) }" style="line-height:22px;font-size: 14px;">
            {{ equipment.toolNo }}
          </p>

          <p style="color: #F4F4F4;line-height:22px;font-size: 14px;">
            <span>{{ $t("收集批次") }}</span>&nbsp; <span :style="{ color: cardTextColor(index) }">{{ equipment.batchNo }}</span>
          </p>
          <p style="color: #F4F4F4;line-height:22px;font-size: 14px;">
            <span>{{ $t("物料名称") }}</span>&nbsp; <span :style="{ color: cardTextColor(index) }">{{ equipment.materialName }}</span>
          </p>
          <p style="color: #F4F4F4;line-height:22px;font-size: 14px;">
            <span>{{ $t("首次装车时间") }}</span>&nbsp; <span :style="{ color: cardTextColor(index) }">{{ equipment.firstCollectTime && dayjs(equipment.firstCollectTime).format('MM-DD HH:mm:ss') }}</span>
          </p>
          <p style="color: #F4F4F4;line-height:22px;font-size: 14px;">
            <span>{{ $t("最后装车时间") }}</span>&nbsp; <span :style="{ color: cardTextColor(index) }">{{ equipment.lastCollectTime && dayjs(equipment.lastCollectTime).format('MM-DD HH:mm:ss') }}</span>
          </p>
          <p style="color: #F4F4F4;line-height:22px;font-size: 14px;">
            <span>{{ $t("称重状态") }}</span>&nbsp; <span :style="{ color: cardTextColor(index) }">{{ equipment.weighingStatus && $t(store.state.dictJsonAll['SLAG_WEIGHING_STATUS'][equipment.weighingStatus]) }}</span>
          </p>
          <p style="color: #F4F4F4;line-height:22px;font-size: 14px;">
            <span>{{ $t("称重时间") }}</span>&nbsp; <span :style="{ color: cardTextColor(index) }">{{ equipment.weighingTime && dayjs(equipment.weighingTime).format('MM-DD HH:mm:ss') }}</span>
          </p>
          <p style="color: #F4F4F4;line-height:22px;font-size: 14px;">
            <span>{{ $t("渣包净重") }}</span>&nbsp; <span :style="{ color: cardTextColor(index) }">{{ equipment.netWeight && (equipment.netWeight + 'kg') }}</span>
          </p>

        </div>
      </div>
    </div>
    <div class="bottomBar" style="width: 100%;height: 20px;position: sticky;bottom: 0;background: #202027;"></div>
  </div>
</template>
<script type="text/javascript">
const execMathExpress = require('exec-mathexpress');
export default {
  name: 'web_monitor_workshop_equipment',
  components: {},

  data() {
    return {
      interval: null,
      isStopListScroll: false,
      timmer: null,
      equipments: [],
      equipmentsCal: {},
    };
  },
  computed: {

    cardBarColor() {
      return index => {
        if (this.equipments[index].toolStatus == null) {
          return '#FFD057'
        }
        return {
          '0': '#FFD057',
          '1': '#39F16D',
        }[this.equipments[index].toolStatus];
      }
    },
    cardTextColor() {
      return index => {

        if (this.equipments[index].toolStatus == null) {
          return '#FFC83A'
        }

        return {
          '0': '#FFC83A',
          '1': '#39F16D',

        }[this.equipments[index].toolStatus];
      };
    },

  },
  watch: {
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.getEquipmentMonitorBoard();
    }
  },
  created() {

    this.timmer = setInterval(() => {
      this.getToolMonitor();
    }, 120000);
    this.getToolMonitor();


  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {
    clearInterval(this.timmer);
  },
  methods: {
    setAutoScroll(speed = 1) {
      if (this.interval) {
        clearInterval(this.interval);
      }

      const listDiv = this.$refs.cardContainer;

      this.interval = setInterval(() => {
        if (!this.store.state.is_monitor_full) {
          return;
        }
        if (!this.isStopListScroll) {
          listDiv.scrollTop += speed / window.devicePixelRatio + 0.05;
          if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
            this.isStopListScroll = true;
            this.monitorSetting.MONITOR_WORKSHOP_CARD_SPEED = speed
            setTimeout(() => {
              if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
                listDiv.scrollTop = 0;
              }
              this.isStopListScroll = false;
            }, 5000);
          }
        }
      }, 100);
    },


    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => { }, 800);
    },
    getToolMonitor() {
      this.http
        .get('/web/slag/collection/record/toolMonitor', {
          params: {
            orgId: this.$attrs.orgId
          }
        })
        .then(res => {
          let datas = []
          //循环res.data对象keys，获取key
          for (let key in res.data) {
            if (key == 'calcMap') {
              continue;
            }
            let data = res.data[key];
            datas.push(data);
          }



          //排序data
          datas.sort((a, b) => {
            return a.toolName - b.toolName;
          });


          this.equipments = datas; // 筛选出所有设备id
          this.equipmentsCal = res.data.calcMap
        });
    }
  }

};
</script>
